import { render, staticRenderFns } from "./FolderStatus.vue?vue&type=template&id=6a76df4d&scoped=true&lang=pug"
import script from "./FolderStatus.vue?vue&type=script&lang=ts"
export * from "./FolderStatus.vue?vue&type=script&lang=ts"
import style0 from "./FolderStatus.vue?vue&type=style&index=0&id=6a76df4d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76df4d",
  null
  
)

export default component.exports